import React from 'react'

function Loader() {
  return (
    <div>Loading...</div>
  )
}

export default Loader